import classnames from 'classnames';

import {Checkbox} from 'shells/checkbox/checkbox';

import styles from './field-toggle-button.module.css';

type Props = {
    label: string;
    isSelected: boolean;
    onClick: () => void;
};

export function FieldToggleButton(props: Props) {
    return (
        <button
            className={classnames(
                styles['field-toggle'],
                props.isSelected && styles['field-toggle--selected']
            )}
            onClick={() => {
                props.onClick();
            }}
        >
            <Checkbox
                checked={props.isSelected}
                isLarge={true}
                label={<div className='pl-12'>{props.label}</div>}
                labelColor='dark'
                onClick={(e) => e.stopPropagation()}
                onChange={() => props.onClick()}
            />
        </button>
    );
}
